export enum DeliveryDateSourceEnum {
  SupplierProvided = 'Supplier Provided',
  SignOffDate = 'Sign-off Date',
}
